<template>
  <div class="grid grid-cols-2 lg:grid-cols-3 col-gap-8 row-gap-12 relative">
    <BaseInput v-model.trim="$v.form.goal_title.$model"
               class="col-span-2 lg:col-span-3"
               :label="$t('goalNameLabel')"
               :class="{'--error':$v.form.goal_title.$error}">
      <template v-slot:errors>
        <div class="error" v-if="!$v.form.goal_title.required">{{ $t('errors.required') }}</div>
      </template>
    </BaseInput>
    <ValueInput v-model.trim="$v.form.goal_sum.$model"
                :label="$t('goalSumLabel')"
                :currency_id="goalCurrency.id"
                text-align="left"
                :class="{'--error':$v.form.goal_sum.$error}">
      <template v-slot:errors>
        <div class="error" v-if="!$v.form.goal_sum.required">{{ $t('errors.required') }}</div>
      </template>
    </ValueInput>
    <VueDatePicker v-model="form.date_start"
                   type="month"
                   :locale="{lang:$i18n.locale}"
                   color="#486680">
      <template #activator="{ date }">
        <div class="relative w-full">
          <BaseInput class="w-full cursor-pointer"
                     :label="$t('firstPaymentDate')"
                     readonly
                     v-model="date">
          </BaseInput>
          <IconCalendar class="text-border-hover absolute right-4 top-0 bottom-0 m-auto"/>
        </div>
      </template>
    </VueDatePicker>
    <VueDatePicker v-model="form.date_end"
                   type="month"
                   :min-date="minDateEnd"
                   :max-date="maxDateEnd"
                   :locale="{lang:$i18n.locale}"
                   color="#486680">
      <template #activator="{ date }">
        <div class="relative w-full">
          <BaseInput class="w-full cursor-pointer"
                     :label="$t('goalAchievementDate')"
                     readonly
                     v-model="date">
          </BaseInput>
          <IconCalendar class="text-border-hover absolute right-4 top-0 bottom-0 m-auto"/>
        </div>
      </template>
    </VueDatePicker>
    <BaseTextarea class="col-span-2 lg:col-span-3 one-line" v-model="form.description" :label="$t('noteLabel')"/>
    <div class="flex col-span-2 lg:col-span-3">
      <BaseButton theme="red" class="lg:w-78 mr-12" :loading="submitted" @click="apply">{{ $t('save') }}</BaseButton>
      <BaseButton theme="white" class="lg:w-78" :loading="submitted" @click="$emit('cancel')">{{ $t('cancel') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import BaseButton from "@/components/UI/BaseButton";
import BaseTextarea from "@/components/UI/BaseTextarea";
import ValueInput from "@/components/UI/BaseInput/ValueInput";
import BaseRadioGroup from "@/components/UI/BaseRadioGroup";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import IconCalendar from "@/components/icons/IconCalendar";

export default {
  name: "GoalEditForm",
  components: {IconCalendar, BaseInput, BaseRadioGroup, ValueInput, BaseTextarea, BaseButton, VueDatePicker},
  props: {
    submitted: {
      type: Boolean
    },
    editGoal: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        goal_title: null,
        goal_sum: null,
        date_start: null,
        date_end: null,
        description: '',
      }
    }
  },
  validations: {
    form: {
      goal_title: {
        required
      },
      goal_sum: {
        required
      },
    },
  },
  computed: {
    minDateEnd() {
      return this.$moment(this.form.date_start, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
    },
    maxDateEnd() {
      return this.$moment(this.form.date_start, 'YYYY-MM').add(100, 'year').format('YYYY-MM');
    },
    goalCurrency() {
      return this.editGoal.currency;
    }
  },
  methods: {
    setFormFields() {
      this.form.goal_title = this.editGoal.goal_title;
      this.form.goal_sum = this.editGoal.goal_sum;
      this.form.date_start = this.$moment.unix(this.editGoal.goal_date_start).format('YYYY-MM');
      this.form.date_end = this.$moment.unix(this.editGoal.goal_date_end).format('YYYY-MM');
      this.form.description = this.editGoal.description;
    },
    handleDateStart() {
      let months = this.$moment(this.form.date_end, 'YYYY-MM')
          .diff(this.$moment(this.form.date_start, 'YYYY-MM'), 'months')
      if (months > 1200) {
        this.form.date_end = this.$moment(this.form.date_start, 'YYYY-MM').add(100, 'year');
      }
    },
    apply() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let {goal_title, goal_sum, date_start, date_end, description} = this.form;
        let data = {
          id: this.editGoal.id,
          goal_title, goal_sum, date_start, date_end, description
        }
        this.$emit('save', data);
      }
    }
  },
  created() {
    this.setFormFields();
  },
  watch: {
    'form.date_start': 'handleDateStart'
  },
  i18n: {
    messages: {
      en: {
        goalNameLabel: 'Goal name',
        goalSumLabel: 'Goal sum',
        firstPaymentDate: 'First payment date',
        goalAchievementDate: 'Goal achievement day',
        noteLabel: 'Description',
        save: 'Save',
        cancel: 'Cancel',
        errorSetMorePayment: 'Increase your payment: finish date is more than in 100 years'
      },
      ru: {
        goalNameLabel: 'Название',
        goalSumLabel: 'Сумма цели',
        firstPaymentDate: 'Дата первого платежа',
        goalAchievementDate: 'Дата достижения цели',
        noteLabel: 'Заметка',
        save: 'Сохранить',
        cancel: 'Отмена',
        errorSetMorePayment: 'Увеличьте платеж: эта цель больше чем на 100 лет'
      },
    }
  }
}
</script>
